<template>
	<div class="login pb-4">
		<div class="col-10 offset-1 col-md-6 offset-md-3 col-lg-4 offset-lg-4 rounded-10 pl-md-0 pr-md-0 background-white box-shadow d-flex mt-n5">
			<LoginComponent/>
		</div>
	</div>
</template>

<script>
	import LoginComponent from '@/views//LoginComponent';
	import { mapMutations } from 'vuex';

	export default {
		components:{
			LoginComponent
		},
		methods:{
			...mapMutations('cart', ['updateCart']),
			...mapMutations('auth', ['reset']),
		},
		created() {
			this.$store.dispatch('setPageTitle', 'Login');
			this.updateCart();
		},
		beforeDestroy() {
			this.reset();
		},
	}
</script>
<style scoped>
	.rounded-10 {
		border-radius: 10px;
	}
</style>
